module.exports = "../images/icons/delete.svg";